import React, { useEffect, useState } from 'react';

import { getPatientPhoto } from '../services/patientService';

interface PatientPhotoProps {
  patientId?: string | null;
  hasPhoto?: boolean;
  photoVersion?: string;
  token?: string | null;
  alt: string;
  className?: string;
  fallback?: React.ReactNode;
}

const PatientPhoto: React.FC<PatientPhotoProps> = ({
  patientId,
  hasPhoto = false,
  photoVersion,
  token,
  alt,
  className,
  fallback = null,
}) => {
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!patientId || !hasPhoto || !token) {
      setPhotoUrl(null);
      return;
    }

    const controller = new AbortController();
    let active = true;
    let objectUrl: string | null = null;

    void getPatientPhoto(patientId, token, controller.signal, photoVersion)
      .then(blob => {
        if (!active) {
          return;
        }
        objectUrl = URL.createObjectURL(blob);
        setPhotoUrl(objectUrl);
      })
      .catch(() => {
        if (active) {
          setPhotoUrl(null);
        }
      });

    return () => {
      active = false;
      controller.abort();
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [hasPhoto, patientId, token, photoVersion]);

  return photoUrl ? (
    <img
      className={className}
      src={photoUrl}
      alt={alt}
      draggable={false}
    />
  ) : (
    <>{fallback}</>
  );
};

export default PatientPhoto;
